import { setMode } from '@stencil/core';

/* START GENAI@CHATGPT4 */
setMode(elm => {
  // supports custom or default for now
  return (elm as any).mode || elm.getAttribute('mode') || 'default';
});
/* END GENAI@CHATGPT4 */
